// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8842ff14","488":"d3735cac","644":"71113c48"}[chunkId] + ".chunk.js";
};